<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left"></div>
				<div class="sf-actions__right">
					<!--저장 -->
					<sf-button size="sm" v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
						{{ getMessage_('QWCC001131') }}
					</sf-button>
				</div>
			</div>
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">* {{ getMessage_('QWCC000956') }}</th>
							<!--품번-->
							<td class="col-1">
								<el-input :value="masterInfo.partNo" readonly />
							</td>
							<th class="col-1">{{ getMessage_('QWCC000957') }}</th>
							<!--품명-->
							<td class="col-3" colspan="3">
								<el-input :value="masterInfo.partNm" readonly />
							</td>
							<th class="col-1">* {{ getMessage_('QWCC001167') }}</th>
							<!--시작일-->
							<td class="col-1">
								<el-date-picker
									:value="masterInfo.strtDd"
									readonly
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									@input="val => onChangeSelect(val, 'strtDd')"
								/>
							</td>
							<th class="col-1">* {{ getMessage_('QWCC000954') }}</th>
							<!--종료일-->
							<td class="col-1">
								<el-date-picker
									:value="masterInfo.endDd"
									readonly
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									@input="val => onChangeDt(val, 'endDd')"
								/>
							</td>
						</tr>
						<tr>
							<th class="col-1">* {{ getMessage_('QWCC000958') }}</th>
							<!--협력사-->
							<td class="col-1">
								<el-input :value="masterInfo.cpnyCd" readonly type="text" @input="val => onChangeSelect(val, 'cpnyCd')" />
							</td>
							<th class="col-1">{{ getMessage_('QWCC001342') }}</th>
							<!--협력사명-->
							<td class="col-3" colspan="3">
								<el-input :value="masterInfo.cpnyNm" readonly />
							</td>
							<th class="col-1">{{ getMessage_('QWCC001924') }}</th>
							<!--실납품사-->
							<td class="col-3" colspan="3">
								<el-input :value="masterInfo.dlvgNm" type="text" maxlength="30" @input="val => onChangeRtsh(val, 'dlvgNm')" readonly />
							</td>
						</tr>
						<tr>
							<th class="col-1">* {{ getMessage_('QWCC001023') }}</th>
							<!--보증사용거리(만Km)-->
							<td class="col-1">
								<el-input :value="masterInfo.milg" type="number" @input="val => onChangeSelect(val, 'milg')" />
							</td>
							<th class="col-1">* {{ getMessage_('QWCC001168') }}</th>
							<!--분담율-->
							<td class="col-1">
								<el-input :value="masterInfo.rtsh" type="number" @input="val => onChangeRtsh(val, 'rtsh')" />
							</td>
							<th class="col-1">* {{ getMessage_('QWCC001351') }}</th>
							<!--보증기간(년)-->
							<td class="col-1">
								<el-input :value="masterInfo.usePrd" type="number" @input="val => onChangeSelect(val, 'usePrd')" />
							</td>
							<th class="col-1">* {{ getMessage_('QWCC001165') }}</th>
							<!--부품원가-->
							<td class="col-1">
								<el-input :value="masterInfo.partCst" readonly type="number" @input="val => onChangeSelect(val, 'partCst')" />
							</td>
							<th class="col-1">* {{ getMessage_('QWCC000973') }}</th>
							<!--기종-->
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="masterInfo.tymaCd"
									:onChange="val => onChangeSelect(val, 'tymaCd')"
									:options="tymaCdList"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import moment from 'moment';
import * as yup from 'yup';
export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: '',
			pprNo: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {
		await this.getCommCodes_({ key: 'tymaCdList', codeType: 'FLCL_SPC_CST' }); //기종
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({
				// dlvgNm: yup //실납품사
				// 	.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001924')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001924')])),
				milg: yup //보증거리
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001023')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001023')])),
				usePrd: yup //보증기간
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001351')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001351')])),
				tymaCd: yup //기종
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000973')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000973')])),
				endDd: yup //종료일
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000954')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000954')])),
				strtDd: yup //시작일
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001167')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001167')])),
				rtsh: yup //분담율
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001168')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001168')])),
				cpnyCd: yup //업체코드
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000950')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000950')])),
				aplPartCst: yup //부품가
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001169')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001169')])),
				partNo: yup //품번
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000956')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000956')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		//글자수 제한 이벤트
		onChangeSelect(value, key) {
			if (key === 'partCst') {
				value = value?.length > 7 ? value.slice(0, 6) : value;
			}
			if (key === 'rtsh') {
				value = value?.length > 3 ? value.slice(0, 3) : value;
			}
			if (key === 'usePrd') {
				value = value?.length > 2 ? value.slice(0, 2) : value;
			}
			if (key === 'milg') {
				value = value?.length > 3 ? value.slice(0, 3) : value;
			}
			this.setMasterInfo_({ key, value });
		},
		onChangeDt(value, key) {
			//value = 종료일의 value값이 시작일보다 작을때 에러메세지를 띄우고, 오늘날짜로 값을 셋팅한다.
			try {
				if (value < this.masterInfo.strtDd) {
					let today = moment().format('YYYYMMDD');
					this.setMasterInfo_({ key, value: today });
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001778'))); //종료일자는 시작일자보다 빠를 수 없습니다.
				} else {
					this.setMasterInfo_({ key, value });
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		onChangeRtsh(value, key) {
			try {
				if (value > 100) {
					this.setMasterInfo_({ key: 'rtsh', value: '' });
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001776'), [this.getMessage_('QWCC001168')])); //100보다 클 수 없습니다.
				} else {
					this.setMasterInfo_({ key, value });
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		//저장 이벤트
		saveAction() {
			try {
				const saveParams = this.masterInfo;

				//벨리데이션 체크
				this.insVali.validateSync(saveParams);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save(saveRows) {
			this.$sf_toggleLoading(true);

			const saveParams = this.masterInfo;

			const params = { saveParams: saveParams };

			await this.savePartCost_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$emit('Refresh');
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
